// extracted by mini-css-extract-plugin
export default {"modal__title":"styles_modal__title__0VaYm","modal__content":"styles_modal__content__Z7Kve","modal":"styles_modal__gmYBp","modal__btns":"styles_modal__btns__y0ss3"};